import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SERVICE_AREAS, PHONE_TEL } from "@/lib/constants";

export const ServiceAreas = () => {
    const { t } = useLang();

    return (
        <section id="service-areas" data-testid="service-areas-section" className="relative py-20 lg:py-28 border-t border-white/5">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid gap-12 lg:grid-cols-12 items-start">
                    <motion.div
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.7 }}
                        className="lg:col-span-4 text-center lg:text-left lg:sticky lg:top-28"
                    >
                        <span className="text-xs font-extrabold uppercase tracking-[0.25em] text-volt">
                            {t("areas.eyebrow")}
                        </span>
                        <h2 className="mt-4 font-display text-3xl sm:text-4xl font-black tracking-tight text-white">
                            {t("areas.h")}
                        </h2>
                        <p className="mt-4 text-base leading-relaxed text-slate-400">{t("areas.sub")}</p>
                        <a
                            href={PHONE_TEL}
                            data-testid="areas-call-card"
                            className="mt-7 flex items-center gap-4 rounded-2xl border border-volt/25 bg-volt/[0.07] p-5 text-left transition-all hover:border-volt/60 hover:bg-volt/10"
                        >
                            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-volt">
                                <Phone className="h-5 w-5 text-obsidian" />
                            </span>
                            <span>
                                <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">
                                    {t("areas.note")}
                                </span>
                                <span className="block font-display text-lg font-black text-white">(346) 318-5888</span>
                            </span>
                        </a>
                    </motion.div>

                    <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                        {SERVICE_AREAS.map((area, i) => (
                            <motion.div
                                key={area}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.1 }}
                                transition={{ duration: 0.45, delay: (i % 8) * 0.06 }}
                                data-testid={`area-chip-${i}`}
                                className="flex items-center gap-2.5 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3.5 text-sm font-bold text-slate-300 transition-all hover:border-volt/50 hover:bg-volt/[0.08] hover:text-volt"
                            >
                                <MapPin className="h-4 w-4 shrink-0 text-volt" />
                                <span className="truncate">{area}</span>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceAreas;
